// extracted by mini-css-extract-plugin
module.exports = {"PizzaControls":"PizzaControls_PizzaControls__1vu-W","select":"PizzaControls_select__3ukg9","slider":"PizzaControls_slider__2a-eA","gramValue":"PizzaControls_gramValue__3ZzJF"};